import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { Component, NgModule, OnInit, Input, Output, EventEmitter, HostListener, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { AddGroupComponent } from 'app/admin/groups/addgroup/add-group.component';
import { ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Group } from 'app/admin/groups/group.model';
import { GroupService } from 'app/admin/groups/group.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';

@Component({
    selector: 'group-list',
    providers: [GroupService],
    templateUrl: './group-list.component.html',
    styleUrls: ['./group-list.component.css']
})

/**
 * Component to display the group list.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class GroupListComponent implements OnInit {
    add = 'Add';
    edit = 'Edit';
    dialogRef: MdDialogRef<any>;
    groupRecords: Group[];
    groupsLoaded = false;
    selectedGroup: Group;

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        private groupService: GroupService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    ngOnInit() {
        this.getGroupList();
    }

    getGroupList() {
        let formattedGroupRecords = [];
        this.groupService.getGroups()
            .subscribe(response => {
                this.groupRecords = response;
                this.groupsLoaded = true;
            }
            );
    }

    openAddGroupDialog(action: string) {
        const config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(AddGroupComponent, config);
        this.dialogRef.componentInstance.selectedGroup = this.selectedGroup;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
            this.selectedGroup = null;
            setTimeout(() => { this.getGroupList() }, 2000)
        });
    }

    deleteGroup(group: Group): void {
        const groupModel = new Group();
        groupModel.id = group.id;
        this.groupService.deleteGroup(groupModel)
            .subscribe(response => {
                if (response.flagResult) {
                    this.groupRecords.splice(this.groupRecords.indexOf(group), 1);
                }
                this.trackingService
                    .emitEvent(
                    TrackingConstants.GROUP_MANAGEMENT,
                    TrackingConstants.GROUP_DELETE,
                    TrackingConstants.SUCCESS, 1);
                this.callSnackBarService(response);
            }, err => {
                this.trackingService
                    .emitEvent(
                    TrackingConstants.GROUP_MANAGEMENT,
                    TrackingConstants.GROUP_DELETE,
                    TrackingConstants.FAILURE, 0);
                this.callSnackBarService(err);
            });
    }

    openEditGroupDialog(value: Group): void {
        this.selectedGroup = value;
        this.openAddGroupDialog(this.edit);
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.DELETE_GROUP_SUCCESS,
            MessageService.GROUP_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/groups/grouplist/group-list.component.ts